module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "padding": ".2rem 0 1rem 0",
      "height": "100%"
    }
  }, [_c('van-form', {
    on: {
      "submit": _vm.onSubmit,
      "failed": _vm.onFailed
    }
  }, [_c('van-cell-group', [_c('van-field', {
    attrs: {
      "rules": [{
        required: true,
        message: ''
      }],
      "label": "单位名称",
      "input-align": "right",
      "error-message-align": "right",
      "clearable": "",
      "placeholder": "请输入单位关键字"
    },
    scopedSlots: _vm._u([{
      key: "button",
      fn: function() {
        return [_c('van-button', {
          attrs: {
            "native-type": "button",
            "size": "small",
            "type": "primary"
          },
          on: {
            "submit": function($event) {
              $event.preventDefault();
            },
            "click": _vm.searchUser
          }
        }, [_vm._v("搜索")])]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.keywords),
      callback: function($$v) {
        _vm.keywords = $$v
      },
      expression: "keywords"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "operate-desc-left"
  }, [_vm._v("请输入单位名称或者部分关键字，系统会模糊匹配")]), _vm._v(" "), _c('van-radio-group', _vm._l((_vm.userList), function(user, index) {
    return _c('van-cell', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.formData.user_id == 0 || _vm.formData.user_id == user.id),
        expression: "formData.user_id==0 || formData.user_id==user.id"
      }],
      attrs: {
        "title": user.danwei,
        "is-link": ""
      },
      on: {
        "click": function($event) {
          _vm.formData.user_id = user.id;
          _vm.formData.phone = user.phone
        }
      },
      scopedSlots: _vm._u([{
        key: "label",
        fn: function() {
          return [_vm._v("\n                        用户组：" + _vm._s(user.rolename)), _c('br'), _vm._v("\n                        用户名：" + _vm._s(user.name)), _c('br'), _vm._v("\n                        手机： " + _vm._s(_vm._f("hide")(user.phone)) + "\n                    ")]
        },
        proxy: true
      }], null, true)
    })
  }), 1), _vm._v(" "), (_vm.formData.user_id) ? _c('van-field', {
    attrs: {
      "rules": [{
        required: true,
        message: '请输入完整的手机号'
      }],
      "label": "手机号",
      "type": "number",
      "input-align": "right",
      "error-message-align": "right",
      "clearable": "",
      "placeholder": "请输入完整的手机号"
    },
    model: {
      value: (_vm.formData.phone2),
      callback: function($$v) {
        _vm.$set(_vm.formData, "phone2", $$v)
      },
      expression: "formData.phone2"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.formData.user_id) ? _c('van-field', {
    attrs: {
      "rules": [{
        required: true,
        message: '请输入密码'
      }],
      "label": "新密码",
      "type": "password",
      "input-align": "right",
      "error-message-align": "right",
      "clearable": "",
      "placeholder": "请输入CCA官网新密码"
    },
    model: {
      value: (_vm.formData.password),
      callback: function($$v) {
        _vm.$set(_vm.formData, "password", $$v)
      },
      expression: "formData.password"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.formData.user_id) ? _c('van-field', {
    attrs: {
      "rules": [{
        required: true,
        message: '请再次输入密码'
      }],
      "label": "重复密码",
      "type": "password",
      "input-align": "right",
      "error-message-align": "right",
      "clearable": "",
      "placeholder": "请再次输入密码"
    },
    model: {
      value: (_vm.formData.password2),
      callback: function($$v) {
        _vm.$set(_vm.formData, "password2", $$v)
      },
      expression: "formData.password2"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.formData.user_id) ? _c('div', {
    staticClass: "savebtn"
  }, [_c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "size": "normal",
      "round": "",
      "native-type": "button"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      },
      "click": function($event) {
        _vm.formData.user_id = 0
      }
    }
  }, [_vm._v("重新选择")]), _vm._v(" "), _c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": "",
      "disabled": _vm.saveLoading,
      "loading": _vm.saveLoading,
      "loading-text": "提交中..."
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("重置密码")])], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-53c1031b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/user/cert/ForgetCcaUser.vue
// module id = 2396
// module chunks = 0